<template>
  <vx-card class="min-h-screen">
		<ResponseAlert ref="response" />
		<vs-table
			:sst="true"
			@sort="sort"
      :data="config.rows"
		>
			<template slot="header">
				<vs-row>
					<vs-col class="mt-5" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
						<vs-row
							class="mb-5"
							vs-align="flex-end"
							vs-type="flex" vs-justify="flex-end" vs-w="12">
							<vs-col class="mr-auto" vs-lg="2" vs-sm="3" vs-xs="12">
								<vs-button :to="'/'+config.uri+'/add'" class="w-full" color="primary" type="filled" icon="add">Add New</vs-button>
							</vs-col>
							<vs-col class="mt-3 md:mt-0 ml-0 md:ml-3" vs-lg="3" vs-sm="4" vs-xs="12">
								<div class="relative">
									<i class="vs-icon notranslate icon-scale material-icons null absolute z-50" style="top: 12px; right: 10px">search</i>
									<vs-input class="w-full" placeholder="Search" v-model="config.search" @input="handleSearch"/>
								</div>
							</vs-col>
						</vs-row>
					</vs-col>
				</vs-row>
      </template>
			<template slot="thead">
				<vs-th :sort-key="row.value" v-for="(row, key) in config.headers" :key="key" :width="row.width" :class="row.class">
					{{row.title}}
				</vs-th>
			</template>
			<template slot-scope="{data}">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" >
					<vs-td :data="data[indextr].name">
						{{data[indextr].name}}
					</vs-td>

					<vs-td :data="data[indextr].isActive">
						<vs-chip :color="getColorStatus(data[indextr].isActive)">
							{{data[indextr].isActive ? 'Active' : 'Inactive'}}
						</vs-chip>
					</vs-td>

					<vs-td class="flex">
						<router-link :to='`/${config.uri}/edit/${data[indextr].id}`' class="text-black text-opacity-50">
							<feather-icon icon="EditIcon" svgClasses="w-5 h-5 mr-3 stroke-current cursor-pointer" />
						</router-link>
            <feather-icon @click="destroy(data[indextr].id)" icon="TrashIcon" svgClasses="w-5 h-5 stroke-current cursor-pointer text-black text-opacity-50" />
          </vs-td>
				</vs-tr>
			</template>
		</vs-table>

		<Pagination :config="config" @gotoPage="gotoPage"/>

	</vx-card>
</template>

<script>
import moment from 'moment'
import {getColorStatus} from '@/utils/helpers'
import api from '@/utils/api'
export default {
		name: 'ListSkinConcerns',
		data() {
			return {
				config: {
					uri: this.$route.meta.link,
					api: api.skinTypes,
					rows: [],
					total_data: 0,
					total_page: 0,
					per_page: 10,
					page: 1,
					orderby: "id",
					sort: "desc",
					search: "",
					debounce: null,
					headers: [{
						title: "Name",
						value: "name",
						align: "text-left",
						width: "50%",
					}, {
						title: "Status",
						value: "isActive",
						align: "text-left",
						width: "25%",
					}, {
						title: "Action",
						value: "",
						class: "text-center",
						width: "25%",
					}],
				},
				getColorStatus,
				moment
			}
		},
		created() {
			const _ = this;
			_.get();
		},
    watch: {
      'config.per_page'() {
        this.config.page = 1
        this.get()
      }
    },
		methods: {
			get() {
				this.$table.get(this.config)
			},
			sort(orderby) {
				if(orderby !== "") this.$table.sort(this.config, orderby)
			},
			gotoPage(page) {
				this.$table.gotoPage(this.config, page)
			},
			destroy(id) {
				this.$vs.dialog({
					type: "confirm",
					color: "danger",
					title: "Confirm",
					text: "Are you sure want to delete this data?",
					acceptText: "Yes",
					cancelText: "No",
					accept: () => {
						this.$axios.delete(`${api.skinTypes}/${id}`)
						.then(res => {
							this.$refs.response.setResponse(res.data, 'success');
							this.get()
						})
						.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'))
					}
				})
			},

			handleSearch() {
				clearTimeout(this.debounce)
				this.debounce = setTimeout(() => {
          this.config.page = 1
          this.get()
				}, 300)
			},
		},
	}
</script>

<style>

</style>
